import React, { useState, useEffect } from "react";
import "./AIDemoV2.css";
import useChat from "../auth/util/useChatV2";
import Header from "./Header";
import { useDispatch } from "react-redux";
import { getUserSubInterestsAction } from "../actions/profileActions";
import { Alert, Box, Snackbar } from "@mui/material";
import { Loading } from "react-admin";
import Loader2 from "./Loader2";

const TakeAssessment = () => {
  const dispatch = useDispatch();
  const {
    sendMessage,
    messages,
    setMessages,
    setSystemPrompt,
    initResponse,
    attemptDetails,
    generatingMessage,
  } = useChat();

  const [openToast, setOpenToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [severityClass, setSeverityClass] = useState("success");
  const [questionLoader, setQuestionLoader] = useState(false);

  const [questions, setQuestions] = useState([
    {
      id: 1,
      question: "What is smallest Prime Number after 1?",
      options: ["1", "2", "3", "4"],
      answer: 1, // index of the correct answer
      marks: 5,
    },
    {
      id: 2,
      question: "What is 3 + 3?",
      options: ["1", "2", "3", "6"],
      answer: 3, // index of the correct answer
      marks: 5,
    },
    {
      id: 3,
      question: "What is 5 + 5?",
      options: ["1", "2", "3", "10"],
      answer: 3, // index of the correct answer
      marks: 5,
    },
    {
      id: 4,
      question: "What is 7 + 7?",
      options: ["1", "2", "3", "14"],
      answer: 3, // index of the correct answer
      marks: 5,
    },
    {
      id: 5,
      question: "What is 9 + 9?",
      options: ["1", "2", "3", "18"],
      answer: 3, // index of the correct answer
      marks: 5,
    },
    {
      id: 6,
      question: "What is 11 + 11?",
      options: ["1", "2", "3", "22"],
      answer: 3, // index of the correct answer
      marks: 5,
    },
    {
      id: 7,
      question: "What is 13 + 13?",
      options: ["1", "2", "3", "26"],
      answer: 3, // index of the correct answer
      marks: 5,
    },
    {
      id: 8,
      question: "What is 15 + 15?",
      options: ["1", "2", "3", "30"],
      answer: 3, // index of the correct answer
      marks: 5,
    },
    {
      id: 9,
      question: "What is 17 + 17?",
      options: ["1", "2", "3", "34"],
      answer: 3, // index of the correct answer
      marks: 5,
    },
    {
      id: 10,
      question: "What is 19 + 19?",
      options: ["1", "2", "3", "38"],
      answer: 3, // index of the correct answer
      marks: 5,
    },
  ]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [showNext, setShowNext] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [answers, setAnswers] = useState({});
  const [selectedOption, setSelectedOption] = useState(null);
  const assessment = {
    id: 1,
    name: "Maths - Know your Numbers - Chapter 1",
    summary:
      "This is a sample assessment for Maths - Know your Numbers - level 1 lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam imperdiet accumsan suscipit. Duis sagittis mauris sit amet tellus suscipit euismod et id nulla. Mauris vulputate posuere velit sit amet feugiat. Etiam sollicitudin scelerisque diam, in dignissim turpis semper id. Quisque nec eleifend nulla. Aenean orci orci, laoreet sed tempu",
    type: 0,
    duration: 60,
    total_marks: 100,
    passing_marks: 40,
    prompt: "Generate difficult questions for the given file.",
    number_of_questions: 10,
    file: {
      id: 1,
      name: "Maths - Know your Numbers - Grade 6",
      summary: "This is a text book for Maths - Know your Numbers - chapter 1",
    },
    questions: [
      {
        id: 1,
        question: "What is smallest Prime Number after 1?",
        options: ["1", "2", "3", "4"],
        answer: 1, // index of the correct answer
        marks: 5,
      },
      {
        id: 2,
        question: "What is 3 + 3?",
        options: ["1", "2", "3", "6"],
        answer: 3, // index of the correct answer
        marks: 5,
      },
      {
        id: 3,
        question: "What is 5 + 5?",
        options: ["1", "2", "3", "10"],
        answer: 3, // index of the correct answer
        marks: 5,
      },
      {
        id: 4,
        question: "What is 7 + 7?",
        options: ["1", "2", "3", "14"],
        answer: 3, // index of the correct answer
        marks: 5,
      },
      {
        id: 5,
        question: "What is 9 + 9?",
        options: ["1", "2", "3", "18"],
        answer: 3, // index of the correct answer
        marks: 5,
      },
      {
        id: 6,
        question: "What is 11 + 11?",
        options: ["1", "2", "3", "22"],
        answer: 3, // index of the correct answer
        marks: 5,
      },
      {
        id: 7,
        question: "What is 13 + 13?",
        options: ["1", "2", "3", "26"],
        answer: 3, // index of the correct answer
        marks: 5,
      },
      {
        id: 8,
        question: "What is 15 + 15?",
        options: ["1", "2", "3", "30"],
        answer: 3, // index of the correct answer
        marks: 5,
      },
      {
        id: 9,
        question: "What is 17 + 17?",
        options: ["1", "2", "3", "34"],
        answer: 3, // index of the correct answer
        marks: 5,
      },
      {
        id: 10,
        question: "What is 19 + 19?",
        options: ["1", "2", "3", "38"],
        answer: 3, // index of the correct answer
        marks: 5,
      },
    ],
  }; //sample assessment data

  const handleCloseToast = () => {
    setOpenToast(false);
  };

  const handleOptionSelection = (index) => {
    console.log("Selected option index:", index);
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questions[currentQuestionIndex].id]: index,
    }));
  };

  const handleSubmit = () => {
    setShowLoader(true);
    console.log("Submitting answers:", answers);
    setTimeout(() => {
      setShowLoader(false);
      setToastMsg("Assessment submitted successfully");
      setSeverityClass("success");
      setOpenToast(true);
      setCurrentQuestionIndex(0);
      setAnswers({});
    }, 1000);
  };

  useEffect(() => {
    console.log("Answers:", answers);
    console.log(answers[questions[currentQuestionIndex].id]);
  }, [answers]);

  useEffect(() => {
    dispatch(getUserSubInterestsAction(localStorage.getItem("userDetailsID")));
  }, []);

  return (
    <div className="ai-demo-wrapper">
      <Header />

      <Snackbar
        open={openToast}
        autoHideDuration={3500}
        onClose={handleCloseToast}
      >
        <Alert
          variant="filled"
          onClose={handleCloseToast}
          severity={severityClass}
          sx={{ width: "100%" }}
        >
          {toastMsg}
        </Alert>
      </Snackbar>

      {showLoader && <Loader2 />}

      <Box
        sx={{
          display: "flex",
          width: "100%",
          height: "90vh",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div
          className="main-panel"
          style={{
            flex: 1,
            background: "#f6f6f6",
            display: "flex",
          }}
        >
          <div
            className="question-option-panel"
            style={{
              width: "70%",
              display: "flex",
              flexDirection: "column",
              borderRight: "2px solid rgba(0, 0, 0, 0.1)",
              transition: "all 0.3s",
              overflow: "auto",
            }}
          >
            <div
              className="question"
              style={{
                height: "70%",
                borderBottom: "2px solid rgba(0,0,0,0.1)",
                padding: "0.5rem",
                overflowY: "scroll",
              }}
            >
              <div
                className="header"
                style={{
                  height: "7%",
                  minHeight: "50px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  padding: "0.2rem",
                  paddingLeft: "0.2rem",
                  fontSize: "1.2rem",
                  fontWeight: "600",
                  borderBottom: "1px solid rgba(0,0,0,0.1)",
                  transition: "all 0.3s",
                }}
              >
                Mathematics - Know your numbers
              </div>
              {questionLoader ? (
                <Loading loadingPrimary="" loadingSecondary="loading..." />
              ) : (
                <div
                  className="questionContent"
                  style={{
                    padding: "0.5rem",
                    fontSize: "1rem",
                  }}
                >
                  <div>{questions[currentQuestionIndex].question}</div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      gap: "1rem",
                      alignItems: "center",
                      margin: "0.5rem 0",
                    }}
                  >
                    {!(questions?.length === currentQuestionIndex + 1) && (
                      <div
                        className="nextBtn"
                        style={{
                          background: "#04a5a6",
                          color: "white",
                          padding: "0.5rem",
                          borderRadius: "7px",
                          cursor: "pointer",
                          textAlign: "center",
                          transition: "0.2s ease-in-out",
                          maxWidth: "max-content",
                          margin: "0.5rem 0",
                          border: "1px solid #04a5a6",
                          boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)",
                          //   animation: "pump 0.6s ease-in-out 3",
                        }}
                        onClick={() =>
                          setCurrentQuestionIndex((prev) => prev + 1)
                        }
                      >
                        Next Question
                      </div>
                    )}
                    {currentQuestionIndex > 0 && (
                      <div
                        className="nextBtn"
                        style={{
                          background: "#04a5a6",
                          color: "white",
                          padding: "0.5rem",
                          borderRadius: "7px",
                          cursor: "pointer",
                          textAlign: "center",
                          transition: "0.2s ease-in-out",
                          maxWidth: "max-content",
                          margin: "0.5rem 0",
                          border: "1px solid #04a5a6",
                          boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)",
                          //   animation: "pump 0.6s ease-in-out 3",
                        }}
                        onClick={() =>
                          setCurrentQuestionIndex((prev) => prev - 1)
                        }
                      >
                        Previous Question
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div
              className="options-content"
              style={{
                marginBottom: "20px",
                fontSize: "1rem",
                display: "flex",
                flexWrap: "wrap",
                height: "35%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {questions[currentQuestionIndex].options?.length > 0
                ? questions[currentQuestionIndex].options.map((item, index) => (
                    <label
                      key={item} // Ensure unique keys
                      className="mcq-option"
                      style={{
                        width: "44%",
                        minHeight: "33%",
                        height: "33%",
                        margin: "0.2rem",
                        padding: "0.5rem",
                        border:
                          answers &&
                          answers[questions[currentQuestionIndex].id] === index
                            ? "2px solid #04a5a6" // Highlight selected option
                            : "1px solid rgba(0,0,0,0.1)",
                        borderRadius: "10px",
                        background:
                          selectedOption === item ? "#e3f2fd" : "white", // Change background when selected
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "0.9rem",

                        textAlign: "center  ",
                        transition: "0.2s ease-in-out",
                      }}
                    >
                      <input
                        type="radio"
                        name="mcq"
                        value={item}
                        checked={selectedOption === item}
                        onChange={() => handleOptionSelection(index)}
                        style={{
                          position: "absolute",
                          opacity: 0,
                          pointerEvents: "none",
                        }}
                        disabled={showNext}
                      />
                      {item}
                    </label>
                  ))
                : ""}
            </div>
          </div>

          <div
            className="chat-wrapper-special"
            style={{
              width: "30%",
              margin: "0",
              height: "100%",
              overflow: "hidden",
              flex: "1",
            }}
          >
            <div
              className="input-and-config-container"
              style={{
                height: "100%",
                overflowY: "scroll",
                padding: "0.5rem",
              }}
            >
              <div>
                {questions && questions.length > 0 && (
                  <>
                    <div
                      className="summary_wrapper"
                      style={{
                        width: "100%",
                        height: "80%",
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      {questions.map((item, index) => (
                        <div
                          style={{
                            color: "white",
                            background: `${
                              index === currentQuestionIndex
                                ? "#04a5a6"
                                : answers && answers[item.id] !== undefined
                                ? "#8cc63c"
                                : "rgba(0, 0, 0, 0.1)"
                            }`,

                            border: "1px solid rgba(0, 0, 0, 0.1)",
                            boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)",
                            width: "40px",
                            height: "40px",
                            borderRadius: "5px",
                            margin: "0.5rem",
                            boxSizing: "border-box",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: "1.2rem",
                            fontWeight: "600",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setCurrentQuestionIndex(index);
                          }}
                        >
                          {index + 1}
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
              <div>
                <button
                  style={{
                    background: "#04a5a6",
                    color: "white",
                    padding: "0.5rem",
                    borderRadius: "7px",
                    cursor: "pointer",
                    textAlign: "center",
                    transition: "0.2s ease-in-out",
                    maxWidth: "max-content",
                    margin: "0.5rem 0",
                    border: "1px solid #04a5a6",
                    boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)",
                  }}
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </Box>
    </div>
  );
};

export default TakeAssessment;
